import React, { useEffect } from "react";
import "./PrivacyPolicy.css";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main className="policy-container">
      <header className="policy-header">
        <h1>Política de Privacidad</h1>
        <p className="policy-updated">
          Última actualización: 27 de Junio de 2025
        </p>
      </header>

      <section className="policy-intro">
        <p>
          En <strong>ZY</strong> valoramos enormemente tu privacidad y estamos
          comprometidos a proteger tus datos personales. Esta Política de
          Privacidad describe qué datos recopilamos, cómo los usamos, y cómo
          puedes ejercer tus derechos relacionados con tus datos.
        </p>
      </section>

      <section className="policy-section">
        <h2>1. Responsable de tus datos</h2>
        <p>
          El equipo fundador de <strong>ZY</strong> es responsable del
          tratamiento y protección de tus datos personales hasta que se
          formalice la incorporación legal de ZY en Estados Unidos.
        </p>
      </section>

      <section className="policy-section">
        <h2>2. Datos que recopilamos</h2>
        <ul>
          <li>
            <strong>Datos personales:</strong> nombre completo, correo
            electrónico, edad, país de residencia.
          </li>
          <li>
            <strong>Datos técnicos:</strong> dirección IP, tipo de navegador,
            sistema operativo, y datos sobre interacciones dentro de la
            plataforma (para fines analíticos y de mejora del servicio).
          </li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>3. Cómo usamos tus datos</h2>
        <p>Tus datos son utilizados exclusivamente para:</p>
        <ul>
          <li>Proporcionar, mantener y mejorar el Servicio.</li>
          <li>
            Personalizar tu experiencia según tus preferencias y necesidades.
          </li>
          <li>
            Comunicarte información importante sobre actualizaciones,
            funcionalidades, cambios en los términos y soporte técnico.
          </li>
        </ul>
        <p>
          Nunca vendemos ni cedemos tus datos personales a terceros con fines
          publicitarios.
        </p>
      </section>

      <section className="policy-section">
        <h2>4. Seguridad de tus datos</h2>
        <p>
          Implementamos medidas técnicas y administrativas para proteger tus
          datos contra accesos no autorizados, alteraciones o destrucción.
        </p>
      </section>

      <section className="policy-section">
        <h2>5. Cookies y tecnologías similares</h2>
        <p>
          Utilizamos cookies y tecnologías similares para mejorar tu experiencia
          y analizar el uso de nuestra plataforma. Puedes configurar tu
          navegador para rechazar cookies, pero algunas funciones podrían verse
          afectadas.
        </p>
      </section>

      <section className="policy-section">
        <h2>6. Tus derechos</h2>
        <p>Tienes derecho a:</p>
        <ul>
          <li>Acceder a tus datos personales almacenados por ZY.</li>
          <li>
            Solicitar la corrección, actualización o eliminación de tus datos
            personales.
          </li>
          <li>
            Oponerte al tratamiento de tus datos personales en ciertos casos.
          </li>
        </ul>
        <p>
          Para ejercer estos derechos, escríbenos a través del formulario en{" "}
          <Link to="/contacto">Contacto</Link>.
        </p>
      </section>

      <section className="policy-section">
        <h2>7. Retención de datos</h2>
        <p>
          Conservamos tus datos solo durante el tiempo necesario para cumplir
          con las finalidades descritas o según los requisitos legales.
        </p>
      </section>

      <section className="policy-section">
        <h2>8. Modificaciones a la Política</h2>
        <p>
          Esta política puede actualizarse para reflejar cambios en prácticas o
          regulaciones. Cualquier cambio significativo será comunicado por
          correo o notificaciones dentro de la plataforma.
        </p>
      </section>

      <section className="policy-section">
        <h2>9. Contacto</h2>
        <p>
          Si tienes preguntas o inquietudes sobre esta política o nuestras
          prácticas de privacidad, contáctanos en:
        </p>
        <p>
          📧 Enviar tu consulta en <Link to="/contacto">Contacto</Link>.
        </p>
        <p>💬 También puedes encontrarnos en nuestras redes sociales</p>
      </section>

      <footer className="policy-footer">
        <p>Al usar ZY, aceptas los términos de esta Política de Privacidad.</p>
      </footer>
    </main>
  );
}
